import { render } from "./FinishSendAdditionalDocView.vue?vue&type=template&id=3f4f3750&scoped=true"
import script from "./FinishSendAdditionalDocView.vue?vue&type=script&lang=js"
export * from "./FinishSendAdditionalDocView.vue?vue&type=script&lang=js"

import "./FinishSendAdditionalDocView.vue?vue&type=style&index=0&id=3f4f3750&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4f3750"]])

export default __exports__